/* Love Maya — scratch popup behaviour.
   Triggers: dwell timer, browse depth, exit intent (desktop) / scroll-up (mobile).
   Frequency: once per visitor, remembered for `data-cooldown` days.
   Email capture: see submitEmail() — wire to Klaviyo/Mailchimp/your endpoint. */
(function () {
  var root = document.getElementById('lm-scratch-root');
  if (!root) return;

  /* ============================================================
     KLAVIYO SETTINGS — fill these two in.
     COMPANY_ID : Klaviyo → Settings → API keys → Public API key (6 chars)
     LIST_ID    : Klaviyo → Audience → Lists → your list → Settings → List ID
     ============================================================ */
  var KLAVIYO_COMPANY_ID = 'TM3LXy';
  var KLAVIYO_LIST_ID    = 'YhqBQc';

  var KEY = 'lm_scratch_v1';
  var DELAY = parseInt(root.dataset.delay || '20', 10) * 1000;
  var PAGEVIEWS = parseInt(root.dataset.pageviews || '2', 10);
  var COOLDOWN = parseInt(root.dataset.cooldown || '30', 10) * 864e5;
  // Fraction of the foil that must be removed before the whole prize is revealed.
  var REVEAL_AT = 0.35;

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function write(patch) {
    var s = read();
    for (var k in patch) s[k] = patch[k];
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
    return s;
  }

  var saved = read();
  // Expired cooldown resets the visitor entirely.
  if (saved.at && Date.now() - saved.at > COOLDOWN) { try { localStorage.removeItem(KEY); } catch (e) {} saved = {}; }
  /* ============================================================
     A/B TEST — scratch popup vs. your existing Klaviyo form.
     Sticky: a visitor stays in one bucket, so never sees both.
     ============================================================ */
  var AB_TEST = false;
  var SPLIT = 0.5;

  /* Testing override: add ?lm=scratch or ?lm=klaviyo to any URL to force a
     bucket, and ?lm=reset to clear yourself back to a brand-new visitor. */
  var forced = (location.search.match(/[?&]lm=(scratch|klaviyo|reset)/) || [])[1];
  if (forced === 'reset') {
    try { localStorage.removeItem(KEY); } catch (e) {}
    document.cookie = 'lm_played=; path=/; max-age=0';
    saved = {};
  }

  var variant = saved.variant;
  if (forced === 'scratch' || forced === 'klaviyo') {
    variant = forced;
    write({ variant: variant, at: Date.now() });
  } else if (AB_TEST && !variant) {
    variant = Math.random() < SPLIT ? 'scratch' : 'klaviyo';
    write({ variant: variant, at: saved.at || Date.now() });
  }
  if (!AB_TEST) variant = 'scratch';

  /* Klaviyo does NOT put the form id in the class — it renders
     "needsclick klaviyo-form klaviyo-form-version-cid_1 go..." — so we match
     the generic .klaviyo-form and remove its overlay wrapper. */
  if (variant === 'scratch') {

    /* Klaviyo locks page scroll when it opens — and since we've hidden its form,
       nothing ever unlocks it. Strip the lock for as long as the page lives.
       This runs on every page, including cart/checkout where the popup itself
       is suppressed. */
    var kvUnlockCss = document.createElement('style');
    kvUnlockCss.textContent =
      'body.klaviyo-prevent-body-scrolling{overflow:visible !important;' +
      'position:static !important;height:auto !important;touch-action:auto !important;}';
    (document.head || document.documentElement).appendChild(kvUnlockCss);

    setInterval(function () {
      var b = document.body, h = document.documentElement;
      if (b.style.overflow === 'hidden') b.style.overflow = '';
      if (h.style.overflow === 'hidden') h.style.overflow = '';
      if (b.style.position === 'fixed') { b.style.position = ''; b.style.top = ''; }
      for (var i = b.classList.length - 1; i >= 0; i--) {
        var c = b.classList[i];
        if (/kl-private|klaviyo|prevent-body-scrolling/i.test(c)) b.classList.remove(c);
      }
    }, 400);
  }

  if (variant === 'klaviyo') return;

  // Suppression: cart/checkout pages, logged-in customers, already played.
  if (root.dataset.suppress === 'true') return;
  if (root.dataset.customer === 'true') return;
  if (saved.claimed) return;

  root.hidden = false;

  var overlay = document.getElementById('lm-overlay');
  var tab     = document.getElementById('lm-tab');
  var tabLbl  = document.getElementById('lm-tab-label');
  var canvas  = document.getElementById('lm-canvas');
  var hint    = document.getElementById('lm-hint');
  var form    = document.getElementById('lm-form');
  var email   = document.getElementById('lm-email');
  var error   = document.getElementById('lm-error');
  var done    = document.getElementById('lm-done');

  // Closed it once already? Never auto-open again on this browser — tab only.
  var autoOpen = !saved.closed;
  var fired = !autoOpen, dismissed = !autoOpen, revealed = false, claimed = false, ctx = null;
  if (!autoOpen) { overlay.hidden = true; overlay.style.display = 'none'; tab.hidden = false; }

  // Safety net: force the page scrollable whenever the popup isn't showing.
  var lmUnlockCss = document.createElement('style');
  lmUnlockCss.id = 'lm-unlock';
  lmUnlockCss.textContent =
    'html.lm-unlocked,body.lm-unlocked{overflow:visible !important;' +
    'position:static !important;height:auto !important;top:auto !important;' +
    'touch-action:auto !important;overscroll-behavior:auto !important;}';
  (document.head || document.documentElement).appendChild(lmUnlockCss);

  function lmUnlock() {
    var b = document.body, h = document.documentElement;
    b.style.overflow = ''; h.style.overflow = '';
    b.style.position = ''; b.style.top = ''; b.style.height = '';
    // Klaviyo / theme lock classes
    for (var i = b.classList.length - 1; i >= 0; i--) {
      var c = b.classList[i];
      if (/kl-private|klaviyo|prevent-body-scrolling|lock|no-scroll|noscroll|overflow-hidden|modal-open/i.test(c)) b.classList.remove(c);
    }
    b.classList.add('lm-unlocked'); h.classList.add('lm-unlocked');
  }
  function lmLock() {
    document.body.classList.remove('lm-unlocked');
    document.documentElement.classList.remove('lm-unlocked');
    document.body.style.overflow = 'hidden';
  }
  setInterval(function () { if (overlay.hidden) lmUnlock(); }, 400);
  if (!autoOpen) lmUnlock();

  /* ---------- triggers ---------- */
  function open(why) {
    if (fired || claimed || dismissed) return;
    fired = true;
    overlay.hidden = false;
    overlay.style.display = '';
    tab.hidden = true;
    lmLock();
    paintFoil();
    if (window.gtag) gtag('event', 'scratch_popup_shown', { trigger: why });
  }

  function reopen() {
    overlay.hidden = false;
    overlay.style.display = '';
    tab.hidden = true;
    lmLock();
    if (!revealed) paintFoil();
  }

  function dismiss() {
    overlay.hidden = true;
    overlay.style.display = 'none';
    lmUnlock();
    dismissed = true;
    fired = true;
    if (!claimed) write({ closed: true, at: saved.at || Date.now() });
    if (!claimed) tab.hidden = false;
  }

  /* Which triggers are active. Set any to false to turn it off. */
  var USE_TIMER        = true;   // fires after lm_delay_seconds on the page
  var USE_BROWSE_DEPTH = true;   // fires once they've seen lm_pageviews pages
  var USE_SCROLL_DEPTH = true;   // fires once they've scrolled past SCROLL_PCT
  var USE_EXIT_INTENT  = false;  // cursor leaves the top of the window (desktop)
  var USE_SCROLL_UP    = false;  // fast upward flick (mobile exit-intent proxy)

  var SCROLL_PCT = 45;           // percent of the page scrolled

  var views = (saved.views || 0) + 1;
  write({ views: views, at: saved.at || Date.now() });
  if (USE_BROWSE_DEPTH && views >= PAGEVIEWS) {
    setTimeout(function () { open('browse_depth'); }, 800);
  }

  if (USE_TIMER) setTimeout(function () { open('dwell_timer'); }, DELAY);

  if (USE_EXIT_INTENT) {
    document.addEventListener('mouseout', function (e) {
      if (e.clientY <= 4 && !e.relatedTarget) open('exit_intent');
    });
  }

  var lastY = window.scrollY;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (USE_SCROLL_DEPTH) {
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      if (docH > 0 && (y / docH) * 100 >= SCROLL_PCT) open('scroll_depth');
    }
    if (USE_SCROLL_UP && lastY - y > 60 && y > 400 && window.innerWidth < 750) {
      open('scroll_up');
    }
    lastY = y;
  }, { passive: true });

  /* ---------- scratch surface ---------- */
  var FOIL_W = 332, FOIL_H = 180;
  function paintFoil() {
    var dpr = window.devicePixelRatio || 1;
    // Measure the real panel so the foil fills a responsive card.
    var box = canvas.parentElement;
    var w = Math.round(box.offsetWidth || 332), h = Math.round(box.offsetHeight || 180);
    FOIL_W = w; FOIL_H = h;
    canvas.width = w * dpr; canvas.height = h * dpr;
    ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    var g = ctx.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, '#e7c67f'); g.addColorStop(.5, '#c9a24f'); g.addColorStop(1, '#e0bb73');
    // Overfill by a pixel so no hairline of the prize panel shows at the edges.
    ctx.fillStyle = g; ctx.fillRect(-1, -1, w + 2, h + 2);
    ctx.fillStyle = 'rgba(255,255,255,.5)';
    // Match the store's body font for the foil label.
    var foilFont = getComputedStyle(root).getPropertyValue('--lm-font').trim() || 'sans-serif';
    ctx.font = '600 18px ' + foilFont;
    ctx.textAlign = 'center';
    ctx.fillText('SCRATCH TO REVEAL', w / 2, h / 2 + 6);
    ctx.globalCompositeOperation = 'destination-out';
    canvas.style.width = '100%'; canvas.style.height = '100%';
    canvas.style.transition = 'none';
    canvas.style.opacity = '1';
    canvas.style.pointerEvents = 'auto';
  }

  var drawing = false, last = null;
  function point(e) {
    var r = canvas.getBoundingClientRect();
    var t = (e.touches && e.touches[0]) ? e.touches[0] : e;
    return { x: (t.clientX - r.left) * (FOIL_W / r.width), y: (t.clientY - r.top) * (FOIL_H / r.height) };
  }
  function dot(p) {
    var radius = window.innerWidth < 900 ? 22 : 26;
    ctx.beginPath(); ctx.arc(p.x, p.y, radius, 0, Math.PI * 2); ctx.fill();
  }
  function scratch(e) {
    if (!drawing || !ctx || revealed) return;
    if (e.cancelable) e.preventDefault();
    var p = point(e);
    if (last) {
      var dx = p.x - last.x, dy = p.y - last.y;
      var steps = Math.max(1, Math.round(Math.sqrt(dx * dx + dy * dy) / 8));
      for (var s = 1; s <= steps; s++) dot({ x: last.x + dx * s / steps, y: last.y + dy * s / steps });
    } else dot(p);
    last = p;
    check();
  }
  function check() {
    var img = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    var clear = 0, total = 0;
    for (var i = 3; i < img.length; i += 160) { total++; if (img[i] === 0) clear++; }
    if (clear / total >= REVEAL_AT) reveal();
  }
  function reveal() {
    revealed = true;
    canvas.style.transition = 'opacity .45s';
    canvas.style.opacity = '0';
    canvas.style.pointerEvents = 'none';
    hint.hidden = true;
    form.hidden = false;
    if (window.gtag) gtag('event', 'scratch_revealed');
  }

  canvas.addEventListener('mousedown', function (e) { drawing = true; last = null; scratch(e); });
  window.addEventListener('mousemove', scratch);
  window.addEventListener('mouseup', function () { drawing = false; last = null; });
  canvas.addEventListener('touchstart', function (e) { drawing = true; last = null; scratch(e); }, { passive: false });
  canvas.addEventListener('touchmove', scratch, { passive: false });
  window.addEventListener('touchend', function () { drawing = false; last = null; });

  /* ---------- claim ---------- */
  /* Subscribes the profile to your Klaviyo list with explicit marketing consent
     and stamps a property the welcome flow can trigger on. The discount code
     itself is delivered BY Klaviyo in that email (see INSTALL.md step 6) so
     every visitor gets a unique, single-use code. */
  function submitEmail(addr) {
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Scratch popup',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: addr,
                properties: {
                  scratch_popup_prize: (document.querySelector('.lm-prize__title') || {}).textContent || '',
                  scratch_popup_date: new Date().toISOString(),
                  form_variant: 'custom_test'
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      // Klaviyo returns 202 Accepted with an empty body on success.
      if (!r.ok) throw new Error('Klaviyo ' + r.status);
      return true;
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var addr = (email.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(addr)) { error.hidden = false; return; }
    error.hidden = true;
    var btn = document.getElementById('lm-submit');
    var btnLabel = btn.textContent;
    btn.disabled = true; btn.textContent = 'Sending…';
    submitEmail(addr).then(function () {
      claimed = true;
      form.hidden = true;
      done.hidden = false;
      write({ claimed: true, at: Date.now() });
      if (window.gtag) gtag('event', 'scratch_claimed');
    }).catch(function () {
      btn.disabled = false; btn.textContent = btnLabel;
      error.textContent = 'Something went wrong — please try again.';
      error.hidden = false;
    });
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    if (revealed || overlay.hidden) return;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(paintFoil, 200);
  });

  /* ---------- wiring ---------- */
  document.getElementById('lm-close').addEventListener('click', dismiss);
  document.getElementById('lm-shop').addEventListener('click', dismiss);
  tab.addEventListener('click', reopen);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) dismiss(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) dismiss(); });
  var copyBtn = document.getElementById('lm-copy');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    var code = (document.getElementById('lm-code') || {}).textContent || '';
    navigator.clipboard.writeText(code.trim()).then(function () {
      copyBtn.textContent = 'Copied';
      setTimeout(function () { copyBtn.textContent = 'Copy'; }, 2000);
    });
  });
})();